<template>
  <CockpitDialog
    class="collision-detail-dialog left-520px top-200px"
    title="编辑碰撞检查"
    @close="close"
  >
    <el-form
      :model="formData"
      :rules="formRules"
      ref="collisionForm"
      class="collision-form-wrap mt-15px"
      label-width="120px"
      v-loading="formLoading"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="碰撞编号" prop="no">
            <el-input v-model="formData.no" size="small" placeholder="请填写碰撞编号"></el-input>
          </el-form-item>
          <el-form-item label="主体编码" prop="mainCode">
            <el-input
              v-model="formData.mainCode"
              size="small"
              placeholder="自动回显"
              readonly
            ></el-input>
          </el-form-item>
          <el-form-item label="客体编码" prop="guestCode">
            <el-input
              v-model="formData.guestCode"
              size="small"
              placeholder="自动回显"
              readonly
            ></el-input>
          </el-form-item>
          <el-form-item label="碰撞坐标">
            <div class="position-wrap flex">
              <el-input
                size="small"
                v-model="formData.xPosition"
                placeholder="自动回显"
                readonly
              ></el-input>
              <el-input
                size="small"
                v-model="formData.yPosition"
                placeholder="自动回显"
                class="ml-5px"
                readonly
              ></el-input>
              <el-input
                size="small"
                v-model="formData.zPosition"
                placeholder="自动回显"
                class="ml-5px"
                readonly
              ></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="创建日期" prop="checkTime">
            <el-input
              v-model="formData.checkTime"
              size="small"
              placeholder="自动回显"
              readonly
            ></el-input>
          </el-form-item>
          <el-form-item label="主体名称" prop="mainName">
            <el-input
              v-model="formData.mainName"
              size="small"
              placeholder="自动回显"
              readonly
            ></el-input>
          </el-form-item>
          <el-form-item label="客体名称" prop="guestName">
            <el-input
              v-model="formData.guestName"
              size="small"
              placeholder="自动回显"
              readonly
            ></el-input>
          </el-form-item>
          <el-form-item label="碰撞类型" prop="collisionConfig">
            <el-input
              v-model="formData.collisionConfig"
              size="small"
              placeholder="自动回显"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="碰撞描述" prop="description" class="desc-input">
            <el-input
              v-model="formData.description"
              size="small"
              type="textarea"
              :rows="3"
              placeholder="请填写描述"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-col :span="24" class="flex justify-center">
      <el-button @click="saveHandler" size="small" type="primary" data-marked="true"
        >保存</el-button
      >
      <el-button @click="close" size="small" type="primary" class="ml-20px">取消</el-button>
    </el-col>
  </CockpitDialog>
</template>

<script>
import { cloneDeep } from 'lodash'
import { CollisionCheckApi } from '@wiz-api/collision-detection'
import EventBus from './js/eventBus'

const collisionCheckApi = new CollisionCheckApi()

const CockpitDialog = () => {
  return import('@/components/cockpit/CockpitDialog')
}

export default {
  components: { CockpitDialog },
  props: {
    collisionDetail: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      formLoading: false,
      formData: {
        id: null,
        no: '',
        checkTime: '',
        mainCode: '',
        mainName: '',
        guestCode: '',
        guestName: '',
        xPosition: '',
        yPosition: '',
        zPosition: '',
        description: '',
        collisionType: 0,
      },
      formRules: {
        no: { required: true, message: '请填写碰撞编号', trigger: 'change' },
      },
      actions: []
    }
  },
  watch: {
    'collisionDetail.id': {
      handler(newVal, oldVal) {
        this.formData = this.$options.data().formData
        if (newVal) {
          this.formData = Object.assign(this.formData, this.collisionDetail)
          this.formData.collisionConfig = this.collisionDetail.collisionConfig === 'staticCollision' ? '静态碰撞' : '动态碰撞'
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {},
  async created() {
    this.formData = Object.assign(this.formData, this.collisionDetail.collisionInfo)
    this.formData.collisionConfig = this.collisionDetail.collisionInfo.collisionType === 0 ? '静态碰撞' : '动态碰撞'
    if (this.collisionDetail.actions && this.collisionDetail.actions.length > 0) {
      this.actions = this.collisionDetail.actions.map((item) => {
        let rotation
        if (item.rot) {
          rotation = this.quaternionToEuler(item.xRotation, item.yRotation, item.zRotation, item.wRotation)
        }
        return {
          actionDesc: item.actionDesc,
          keyframeTime: item.keyframeTime,
          no: item.no,
          xPosition: item.xPosition?.toString() || '',
          yPosition: item.yPosition?.toString() || '',
          zPosition: item.zPosition?.toString() || '',
          xRotation: rotation?.x.toString() || '',
          yRotation: rotation?.y.toString() || '',
          zRotation: rotation?.z.toString() || '',
        }
      })
    }
  },
  methods: {
    // 四元数转欧拉角函数
    quaternionToEuler(qw, qx, qy, qz) {
      // 归一化四元数
      const length = Math.sqrt(qw * qw + qx * qx + qy * qy + qz * qz)
      if (length === 0) return { x: 0, y: 0, z: 0 }

      const nw = qw / length
      const nx = qx / length
      const ny = qy / length
      const nz = qz / length

      // 计算欧拉角（弧度）
      // 横滚 (x)
      const sinr_cosp = 2 * (nw * nx + ny * nz)
      const cosr_cosp = 1 - 2 * (nx * nx + ny * ny)
      const roll = Math.atan2(sinr_cosp, cosr_cosp)

      // 俯仰 (y)
      const sinp = 2 * (nw * ny - nz * nx)
      let pitch
      if (Math.abs(sinp) >= 1) {
        pitch = Math.sign(sinp) * Math.PI / 2
      } else {
        pitch = Math.asin(sinp)
      }

      // 偏航 (z)
      const siny_cosp = 2 * (nw * nz + nx * ny)
      const cosy_cosp = 1 - 2 * (ny * ny + nz * nz)
      const yaw = Math.atan2(siny_cosp, cosy_cosp)

      // 弧度转角度
      const radToDeg = 180 / Math.PI
      return {
        x: Number((roll * radToDeg).toFixed(2)),
        y: Number((pitch * radToDeg).toFixed(2)),
        z: Number((yaw * radToDeg).toFixed(2))
      }
    },
    // 关闭阀门详情弹窗
    close() {
      this.$emit('closeCollisionEdit')
    },
    saveHandler() {
      const tenantId =
                localStorage.getItem('CurrentTenantId') ||
                localStorage.getItem('TenantId') ||
                JSON.parse(localStorage.getItem('CurrentUser'))?.TenantId
      this.$refs.collisionForm.validate(async (valid) => {
        if (valid) {
          const [err, res] = await collisionCheckApi.saveCollisionCheck({
            body: {
              collisionInfo: { ...this.formData, tenantId },
              actions: this.actions || [],
            },
          })
          if (!err) {
            this.$message.success('保存成功')
            this.close()
            EventBus.$emit('CollisionEditSuccess')
          }
        }
      })
    },
  },
  beforeDestroy() {},
}
</script>
<style lang="scss" scoped>
.collision-detail-dialog {
  .button-bg-img {
    background: url('../../../assets/images/button_blue.png');
    background-size: 100% 100%;
  }

  ::v-deep .el-loading-mask {
    background: #1a4447ad !important;
  }

  ::v-deep .el-input .el-input__inner {
    width: 250px !important;
    height: 28px !important;
    line-height: 28px !important;
  }

  ::v-deep .el-button {
    height: 36px !important;
    background-color: rgb(67 153 174 / 0.35) !important;
    border: 1px solid #629eaa !important;
    border-radius: 2px !important;
    background-image: none !important;

    &[data-marked='true'] {
      background: linear-gradient(0deg, #4399ae59, #4399ae) !important;
    }
  }

  .position-wrap {
    ::v-deep .el-input {
      width: 80px !important;

      .el-input__inner {
        padding: 0 5px !important;
        width: 100% !important;
      }
    }
  }

  .collision-form-wrap {
    ::v-deep .el-input__inner {
      border: 1px solid #ffffff54 !important;
    }

    ::v-deep .el-textarea__inner {
      border: 1px solid #ffffff54 !important;
    }
  }
}
</style>
